import { render, staticRenderFns } from "./AppletDetail.vue?vue&type=template&id=4b4b6550&"
import script from "./AppletDetail.vue?vue&type=script&lang=js&"
export * from "./AppletDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports